export default "__VITE_ASSET__4Koae9hN__"